import { constants } from "config";
import type { Project } from "../types";

/**
 * Get the etherscan URL for a Project's contract
 *
 * TODO: do we need to determine blockchain?
 */
const getEtherscanURL = (project: Project): string =>
  project.contractAddress
    ? `${constants.etherscanURL}/address/${project.contractAddress}`
    : "";

export { getEtherscanURL };
